export default "__VITE_ASSET__DxkEL4JA__"